var onlyRemoveProjectoverlayHideStyleSheet = function () {
	var style_to_delete = document.getElementById('lay-hide-wrap-for-projectoverlay-css')
	if (style_to_delete) {
		style_to_delete.remove()
	}
}

var onlyRemovePageOverlayHideStyleSheet = function () {
	var style_to_delete = document.getElementById('lay-hide-wrap-for-pageoverlay-css')
	if (style_to_delete) {
		style_to_delete.remove()
	}
}

var removeWrapHideStyleSheet = function () {
	var style_to_delete = document.getElementById('lay-hide-wrap-css')
	if (style_to_delete) {
		style_to_delete.remove()
	}
}

export { onlyRemoveProjectoverlayHideStyleSheet, onlyRemovePageOverlayHideStyleSheet, removeWrapHideStyleSheet }
